// extracted by mini-css-extract-plugin
module.exports = {"noTableSlide":"styles_noTableSlide__2Qr4x"};